export const emptyMedicalContext = {
    medicalDentalExpenses: '',
    homeMortgage: '',
    form1098: '',
    medicalExpense: '',
    medicalPurposes: '',
    realEstateTaxes: '',
    stateLocalTaxes: '',
    contributedCharity: '',
}